import { createApp } from 'vue'
import { router } from '@/router';
import App from './App.vue'
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import VueSelect from 'vue3-select2-component'
import VueFeather from 'vue-feather';
import VueApexCharts from "vue3-apexcharts";
import Vue3Autocounter from 'vue3-autocounter';
import DatePicker from 'vue3-datepicker'
import CKEditor from '@ckeditor/ckeditor5-vue';
import AOS from 'aos';
import 'aos/dist/aos.css';

/*********Layouts component**********/
import layoutsHeader from '@/views/layouts/layouts-header.vue';
import HeaderMenu from '@/views/layouts/header-menu.vue';
import instructorSidebar from '@/views/layouts/instructor-sidebar.vue';
import studentSidebar from '@/views/layouts/student-sidebar.vue';



/********* Home **********/
import footertwo from '@/views/layouts/footer-two.vue'

import CourseInformation from '@/views/pages/dashboard/courses/components/add-course/course-information.vue';
import CourseMedia from '@/views/pages/dashboard/courses/components/add-course/course-media.vue';
import CourseCurriculam from '@/views/pages/dashboard/courses/components/add-course/course-curriculam.vue';
import AdditionalInformation from '@/views/pages/dashboard/courses/components/add-course/additional-information.vue';
import CoursePricing from '@/views/pages/dashboard/courses/components/add-course/course-pricing.vue';

import studentHeader from '@/views/pages/dashboard/student/components/student-header.vue';


import instructorHeader from '@/views/pages/dashboard/instructor/components/instructor-header.vue';
import AddCourseModal from '@/components/modal/add-course-modal.vue';

import CourseSidebar from '@/views/pages/dashboard/courses/components/course/course-sidebar.vue';
import Loginbanner from '@/views/pages/auth/loginbanner.vue';

//custom
import { createPinia } from 'pinia'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import 'vue3-easy-data-table/dist/style.css';
import '@vuepic/vue-datepicker/dist/main.css'

// plugins
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/assets/css/feather.css';
import '@/assets/css/iconsax.css';
import '@/assets/css/tabler-icons.css';
import "boxicons/css/boxicons.min.css";
import '@/assets/scss/main.scss';
  
// Define the feature flag before importing Vue
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = true;

const app = createApp(App)

AOS.init({
    duration: 1200, 
    easing: 'ease-in-out',
    once: true, 
});

/*********Layouts Components**********/
app.component('header-menu', HeaderMenu)
app.component('layouts-header', layoutsHeader)
app.component('instructor-sidebar', instructorSidebar)
app.component('student-sidebar', studentSidebar)

/*********Home**********/
app.component('footer-two', footertwo);

app.component('student-header',studentHeader)

app.component('instructor-header',instructorHeader)

app.component('course-sidebar', CourseSidebar)
app.component('course-information', CourseInformation)
app.component('course-media', CourseMedia)
app.component('course-curriculam', CourseCurriculam)
app.component('additional-information', AdditionalInformation)
app.component('course-pricing', CoursePricing)

app.component('add-course-modal', AddCourseModal)

app.component('login-banner', Loginbanner)


app.component('vue3-autocounter', Vue3Autocounter)
app.component('date-picker', DatePicker);
app.component('vue-select', VueSelect)
app.component(VueFeather.name, VueFeather)

//Custom
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('vSelect', vSelect)

app.use(createPinia())
app.use(VueApexCharts)
.use(BootstrapVue3)
.use(BToastPlugin)
.use(Antd)
app.use(CKEditor)

const isAxiosLikeError = (err) => {
  if (!err || typeof err !== "object") return false;
  // Axios errors always have `isAxiosError` or a `config` + `response`/`request`.
  return (
    err.isAxiosError === true ||
    !!err.config ||
    !!err.response ||
    !!err.request
  );
};

const shouldRedirectToError500 = (err) => {
  // API failures must stay on the current page (toast/Swal handle UX).
  // Redirecting them to /error-500 breaks Principal delete/reject flows.
  if (isAxiosLikeError(err)) return false;
  const msg = String(err?.message || err || "");
  if (/network error|timeout|axios/i.test(msg)) return false;
  return true;
};

app.config.errorHandler = (err) => {
  console.error("Unhandled app error:", err);
  if (
    shouldRedirectToError500(err) &&
    router.currentRoute.value?.name !== "error-500"
  ) {
    router.push("/error-500");
  }
};

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event?.reason);
  if (
    shouldRedirectToError500(event?.reason) &&
    router.currentRoute.value?.name !== "error-500"
  ) {
    router.push("/error-500");
  }
});

window.addEventListener("error", (event) => {
  const isErrorEvent =
    event?.constructor?.name === "ErrorEvent" ||
    typeof event?.message === "string" ||
    !!event?.error;

  if (!isErrorEvent) {
    return;
  }
  const err = event?.error || event?.message;
  console.error("Global error:", err);
  if (
    shouldRedirectToError500(err) &&
    router.currentRoute.value?.name !== "error-500"
  ) {
    router.push("/error-500");
  }
});

app.use(router).mount('#app');
